import React, {useContext} from "react";
import SwivuLoginModal from "./SwivuLoginModal.jsx";
import AuthContext from "../../context/authContext.jsx";
import { loginSocialUser} from "../../../network/network.jsx";
import {SWIVU_HOME_VIEW} from "../../../other/constants/OtherKeys.jsx";
import {setUserFromResponse} from "../../../other/utils/otherUtils.jsx";
import {ReactModal} from "../ReactModal.jsx";
import SwivuSandBox from "./SwivuSandBox.jsx";
import SwivuHomeLayout from "./components/SwivuHomeLayout.jsx";
import SwivuHomeLogo from "./components/SwivuHomeLogo.jsx";
import SwivuHomeMarketingMsg from "./components/SwivuHomeMarketingMsg.jsx";
import SwivuHomeInfo from "./components/SwivuHomeInfo.jsx";

const SwivuHomeModal = () => {
  const {login, initialized, user, displayAuthForm, setLoading, setDisplayAuthForm, isNewSessionRef } = useContext(AuthContext);
  const isMount = ((initialized && !user) || Boolean(displayAuthForm));
  const {isLoggedIn, loggedInAsEmail, loggedInUserProfileImage} = {
    isLoggedIn: user && !user.isDemoUser, loggedInAsEmail: user?.isDemoUser ? "Test Drive User" : user?.email, loggedInUserProfileImage: user?.profile_image_url
  }

  const onCloseModalHandler = () => {
    setDisplayAuthForm(null);
  }

  const onLoginSuccessHandler = (response) => {
    setLoading(true);
    setUserFromResponse(loginSocialUser({...response, provider: "google"}), (data) => {
      setLoading(false);
      if (data) {
        onCloseModalHandler();
        isNewSessionRef.current = true;
        login(data);
        // temporarily comment out the termsAccepted checks, until denis implements it
        // localStorage.setItem("termsAccepted", "true");
      }
    })
  }

  const onContinueBoardHandler = () => {
    onCloseModalHandler();
  }

  if (displayAuthForm?.type === SWIVU_HOME_VIEW.sandbox) {
    return (
      <SwivuSandBox onContinueBoard={(v) => onContinueBoardHandler(v)} />
    );
  }

  if (displayAuthForm?.type === SWIVU_HOME_VIEW.welcome) {
    return (
       <ReactModal isOpen={isMount} close={() => {
      }}>
         <ReactModal.Card
           className="p-1 min-w-full"
           dialogPanelClassName={`w-[100%] max-w-[694px] relative`}
         >
           <SwivuHomeLayout>
              <SwivuHomeLogo />
              <>
                <SwivuHomeMarketingMsg />
                <SwivuHomeInfo loggedInAsEmail={loggedInAsEmail} loggedInUserProfileImage={loggedInUserProfileImage} onContinueBoard={onContinueBoardHandler} welcomeModalData={displayAuthForm.data} />

              </>
            </SwivuHomeLayout>
         </ReactModal.Card>
       </ReactModal>
    )
  }

  if (displayAuthForm?.type === SWIVU_HOME_VIEW.auth) {
    return (
      <ReactModal isOpen={isMount} close={() => {
      }}>
        <ReactModal.Card
          className="p-1 min-w-full"
          dialogPanelClassName={`w-[100%] max-w-[694px] relative`}
        >
          {isMount && !isLoggedIn && (
            <div className="flex">
              <div className="flex flex-[1_0_70%]">
                <SwivuLoginModal
                  onLoginSuccess={onLoginSuccessHandler}
                />
              </div>
            </div>
          )}
        </ReactModal.Card>
      </ReactModal>
    );
  }
  return null;
};

export default SwivuHomeModal;
